import { Component, OnInit } from '@angular/core';

import { MessagingService } from '../../services/messaging.service';

@Component({
  standalone: false,
  selector: 'app-patient-portal',
  templateUrl: './patient-portal.component.html',
  styleUrls: ['./patient-portal.component.css']
})
export class PatientPortalComponent implements OnInit {

  constructor(
    private messagingService: MessagingService,
  ) {
  }

  ngOnInit() {
  }

  testNotifications() {
    //this.messagingService.sendSocketMessage("SOCKET_NOTIFICATION", { message: 'Patient Jessica has checked in for their 3:30 appointment.' });
  }

}
